import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {},
  }
})
